/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum ProcessingStatus {
    Pending = 'Pending',
    Processing = 'Processing',
    Complete = 'Complete',
    Failed = 'Failed',
}
